import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Icon, Eyebrow } from "./publicUI";
import { INDUSTRIES, COMPETENCE, IMG } from "./siteContent";

export default function AreaOfExpertise() {
  const nav = useNavigate();
  return (
    <div>
      <section className="relative brand-gradient-navy overflow-hidden">
        <div className="absolute inset-0 brand-dotgrid opacity-50" />
        <img src={IMG.welder} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F] via-[#0A192F]/90 to-[#0A192F]/40" />
        <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-24">
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-sky-300 mb-3">Area of Expertise</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-[1.05] max-w-3xl">Industries &amp; trades we deploy</h1>
          <p className="mt-5 text-base md:text-lg text-slate-300 max-w-2xl leading-relaxed">
            Two decades of sourcing and deploying skilled, semi-skilled and general workforce across the sectors that build and run economies.
          </p>
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="max-w-2xl"><Eyebrow>Sectors We Serve</Eyebrow>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#0A192F] mt-2">Skilled talent for every sector</h2></div>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {INDUSTRIES.map((ind, i) => (
            <motion.div key={ind.title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.04 }}
              className="bg-white rounded-2xl border border-slate-200 p-6 hover-lift">
              <div className="h-12 w-12 rounded-xl bg-[#0088FF]/10 grid place-items-center text-[#0088FF] mb-4"><Icon name={ind.icon} className="h-6 w-6" /></div>
              <h3 className="font-display font-semibold text-[#0A192F]">{ind.title}</h3>
              <p className="text-sm text-slate-500 mt-2 leading-relaxed">{ind.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* COMPETENCE */}
      <section className="bg-slate-50 border-y border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <div className="max-w-2xl"><Eyebrow>Distinctive Competence</Eyebrow>
            <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#0A192F] mt-2">Built for scale and compliance</h2></div>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {COMPETENCE.map((c, i) => (
              <motion.div key={c.title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }}
                className="bg-white rounded-2xl border border-slate-200 p-6 hover-lift">
                <div className="h-11 w-11 rounded-xl bg-[#0A192F] grid place-items-center text-white mb-3"><Icon name={c.icon} className="h-5 w-5" /></div>
                <h3 className="font-semibold text-[#0A192F]">{c.title}</h3>
                <p className="text-sm text-slate-500 mt-2 leading-relaxed">{c.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="brand-gradient-navy rounded-3xl p-10 lg:p-14 relative overflow-hidden flex flex-col lg:flex-row gap-6 lg:items-center lg:justify-between">
          <div className="absolute inset-0 brand-dotgrid opacity-40" />
          <h2 className="relative font-display text-2xl lg:text-3xl font-bold text-white max-w-xl">Looking for a specific trade or bulk crew?</h2>
          <div className="relative flex gap-3">
            <Button size="lg" data-testid="expertise-cta-quote" onClick={() => nav("/for-employers")} className="bg-[#0088FF] hover:bg-[#0070E0] h-12">Request Workforce <ArrowRight className="h-4 w-4 ml-1" /></Button>
          </div>
        </div>
      </section>
    </div>
  );
}
